import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/home/',
    component:layout,
    children:[
        {name: '运营', path: 'index', component: ()=>_import('index')},
        // add route here
    ]
}